import type { MenuSelectionDetails } from '@ark-ui/solid'
import { IconButton, Menu, appDialogConfirm } from '@components'
import { useService } from 'solid-services'
import { useAuth } from '@state'
import { Link, MoreHorizontal, Pencil, Reply, Trash } from 'lucide-solid'
import { Show } from 'solid-js'
import { HStack } from 'styled-system/jsx'
import { useUpsert } from '../../state'
import type { DisplayMessage } from '../../state/resources/getChannelHistory'
import { useDelete } from '../../state/useDelete'
import ReactionsPick from './ReactionsPick'

enum Options {
	Delete = 'Delete',
	Edit = 'Edit',
	CopyLink = 'CopyLink',
}

const Actions = (props: {
	message: DisplayMessage
	channelPathRoot: string
	isMine?: boolean
	isMinimal?: boolean
}) => {
	const { setDeletingId } = useService(useDelete)()
	const { isSuper } = useService(useAuth)()
	const { setEditingMessage, setReplyMessage } = useService(useUpsert)()

	const onSelect = (details: MenuSelectionDetails) => {
		switch (details.value) {
			case Options.Delete:
				appDialogConfirm(
					() => setDeletingId(props.message.id),
					'Are you sure you want to delete this Message?',
				)()
				break
			case Options.Edit:
				setEditingMessage(props.message)
				break
			case Options.CopyLink:
				navigator.clipboard.writeText(
					`${location.origin}${props.channelPathRoot}/message/${props.message.id}`,
				)
				break
		}
	}

	return (
		<>
    <Show when={!props.isMinimal}>
        <IconButton
          variant="ghost"
          height="20px"
          minWidth="20px"
          onClick={() => setReplyMessage(props.message)}
          >
          <Reply
            width="15px"
            height="15px"
            />
        </IconButton>
      </Show>
			<Menu.Root
				onSelect={onSelect}
				positioning={{
					offset: {
						mainAxis: -15,
					},
				}}
			>
				<Menu.Trigger>
					<IconButton
						height="20px"
						minWidth="20px"
						variant="ghost"
						size="xs"
					>
						<MoreHorizontal
							width="15px"
							height="15px"
						/>
					</IconButton>
				</Menu.Trigger>
				{/* <Portal> */}
				<Menu.Positioner>
					<Menu.Content>
						<Menu.ItemGroup>
							<Menu.Item value={Options.CopyLink}>
								<HStack gap={2}>
									<Link />
									Copy Link
								</HStack>
							</Menu.Item>
							<Show when={isSuper() || props.isMine}>
								<Menu.Item value={Options.Edit}>
									<HStack gap={2}>
										<Pencil />
										Edit
									</HStack>
								</Menu.Item>
							</Show>
							<Show when={isSuper() || props.isMine}>
								<Menu.Item
									value={Options.Delete}
									color="fg.error"
								>
									<HStack gap={2}>
										<Trash color="var(--colors-fg-error)" />
										Delete
									</HStack>
								</Menu.Item>
							</Show>
						</Menu.ItemGroup>
					</Menu.Content>
				</Menu.Positioner>
			</Menu.Root>
			<ReactionsPick
				messageId={props.message.id}
				reactions={props.message.message_reaction}
			/>
		</>
	)
}

export default Actions
